/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BrandInfringement } from './BrandInfringement';
import {
    BrandInfringementFromJSON,
    BrandInfringementFromJSONTyped,
    BrandInfringementToJSON,
    BrandInfringementToJSONTyped,
} from './BrandInfringement';

/**
 * 
 * @export
 * @interface PaginatedBrandInfringementList
 */
export interface PaginatedBrandInfringementList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedBrandInfringementList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedBrandInfringementList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedBrandInfringementList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<BrandInfringement>}
     * @memberof PaginatedBrandInfringementList
     */
    results: Array<BrandInfringement>;
}

/**
 * Check if a given object implements the PaginatedBrandInfringementList interface.
 */
export function instanceOfPaginatedBrandInfringementList(value: object): value is PaginatedBrandInfringementList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedBrandInfringementListFromJSON(json: any): PaginatedBrandInfringementList {
    return PaginatedBrandInfringementListFromJSONTyped(json, false);
}

export function PaginatedBrandInfringementListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedBrandInfringementList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(BrandInfringementFromJSON)),
    };
}

  export function PaginatedBrandInfringementListToJSON(json: any): PaginatedBrandInfringementList {
      return PaginatedBrandInfringementListToJSONTyped(json, false);
  }

  export function PaginatedBrandInfringementListToJSONTyped(value?: PaginatedBrandInfringementList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(BrandInfringementToJSON)),
    };
}

